export const ugovor_o_prijenosu_ugovora = {
    templateId: 49.5,
    category: 16,
    templateTitle: "Ugovor o prijenosu ugovora",
    templateDescription: `<p>Ako jedna ugovorna strana postojećeg ugovora pristane na prijenos ugovora, druga ugovorna strana može prenijeti ugovor na treću osobu koja postaje nositelj svih prava i obveza iz tog ugovora.</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Svaka ugovorna strana može, ako na to pristane druga strana, prenijeti ugovor na neku treću osobu koja time postaje nositelj svih njezinih prava i obveza iz toga ugovora. </p>
    <p>Prijenosom ugovora, ugovorni odnos između prenositelja i druge strane prelazi na primatelja i drugu stranu u času kad je druga strana pristala na prijenos.</p>
    <p>Druga strana može pristanak na prijenos dati:</p>
    <li> unaprijed, ili</li>
    <li> u trenutku samog potpisavanja ugovora o prijenosu ugovora, ili</li>
    <li> naknadno, nakon potpisa ugovora o prijenosu ugovora.</li>
    <br> 
    <p>Ako je druga strana dala svoj pristanak unaprijed,  ugovor prelazi na primatelja i drugu stranu u času kad je druga strana obaviještena o izvršenom prijenosu ugovora. </p>
    <p>Ukoliko je druga strana dala svoj pristanak naknadno, nakon sklapanja ugovora o prijenosu ugovora, ugovor prelazi na primatelja i drugu stranu u trenutku davanja pristanka druge ugovorne strane. </p>
    <p>Pristanak na prijenos ugovora valjan je samo ako je dan u propisanom ili ugovorenom obliku za valjanost prenesenog ugovora.</p>
    <p>Vezano uz odgovornosti za prijenos, važno je raći da prenositelj odgovara za valjanost prenesenog ugovora.</p>
    <p>Prenositelj ne jamči primatelju niti drugoj strani za ispunjenje obveza druge ugovorne strane strane, osim ako se na to obvezao.</p>
    <p><strong>Ako se prenositelj obvezao biti jamac primatelju, drugoj strani ili za svakoga od njih, treba imati na umu da se jamac za obveze iz trgovačkog ugovora smatra jamcem platcem - odgovara za cijelu obvezu te vjerovnik može zahtijevati ispunjenje, bilo od glavnog dužnika, bilo od jamca platca ili od obojice u isto vrijeme.</strong></p>
    <p><strong>Primjer ugovora u nastavku odnosi se na situacije u kojima je druga strana pristanak dala u trenutku sklapanja ugovora o prijenosu, što se i predlaže, radi veće pravne sigurnosti.</strong></p>
    <p><strong>Ipak, ugovor o prijenosu ugovora je dvostrani pravni posao između prenositelja i primatelja, a druga strana isključivo radi veće pravne sigurnosti potpisuje ugovor o prijenosu zajedno s prenositeljem i primateljem ugovora. </strong></p>
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o obveznim odnosima.</p>
  `,

  sides: [
    {
      signature: "Za Prenositelja:",
      inputs: [{
        type: "input",
        required: true,
        placeholder: "Poslovni subjekt",
      },
      {
        type: "input",
        required: true,
        placeholder: "Ulica i kućni broj",
      },
      {
        type: "input",
        required: true,
        placeholder: "Mjesto",
      },
      {
        type: "input",
        required: true,
        placeholder: "OIB",
      },
      {
        type: "input",
        placeholder: "Zastupa",
        inSignature: true,
      },
      {
        type: "input",
        placeholder: "Funkcija",
        inSignature: true,
      }],
      suffix: ' (u daljnjem tekstu: Prenositelj)',
      delimiter: "i"
    },
    {
      signature: "Za  Primatelja:",
      inputs: [{
        type: "input",
        required: true,
        placeholder: "Poslovni subjekt",
      },
      {
        type: "input",
        required: true,
        placeholder: "Ulica i kućni broj",
      },
      {
        type: "input",
        required: true,
        placeholder: "Mjesto",
      },
      {
        type: "input",
        required: true,
        placeholder: "OIB",
      },
      {
        type: "input",
        placeholder: "Zastupa",
        inSignature: true,
      },
      {
        type: "input",
        placeholder: "Funkcija",
        inSignature: true,
      }],
      suffix: ' (u daljnjem tekstu: Primatelj)',
      delimiter: "i"
    },
    {
      signature: "Za Drugu stranu",
      help: "Pristanak na prijenos Druga strana je dala u trenutku sklapanja ugovora o prijenosu Druga strana, što se i predlaže iz razloga veće pravne sigurnosti.  Ipak, pristanak Druge strane može biti dan naknadno odnosno unaprijed.",
      inputs: [{
        type: "input",
        required: true,
        placeholder: "Poslovni subjekt",
      },
      {
        type: "input",
        required: true,
        placeholder: "Ulica i kućni broj",
      },
      {
        type: "input",
        required: true,
        placeholder: "Mjesto",
      },
      {
        type: "input",
        required: true,
        placeholder: "OIB",
      },
      {
        type: "input",
        placeholder: "Zastupa",
        inSignature: true,
      },
      {
        type: "input",
        placeholder: "Funkcija",
        inSignature: true,
      }],
      suffix: ' (u daljnjem tekstu: Druga strana)',
    }
  ],


    headline: 'zaključuju sljedeći',
    title: 'UGOVOR O PRIJENOSU UGOVORA',
    noArticleNumbers: false,

    articles: [

        {
            title: 'PREDMET PRIJENOSA',
            mandatory: true,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: false,
                    parts: [
                        {
                            type: 'text',
                            content: 'Prenositelj i Druga strana su dana'
                        },
                        {type: 'input', value: '', required: true, help: 'Upišite datum.'},
                        {type: 'text', content: '​zaključili'},
                        {type: 'textarea', value: '', required: true, help: 'Upišite naziv Ugovora ili Sporazuma.'},
                        {type: 'text', content: '(u daljnjem tekstu: Ugovor).'}],
                }],
        },
        {
            title: 'PREDMET UGOVORA',
            mandatory: true,
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: false,
                    content: 'Ovim Ugovorom o prijenosu, Prenositelj prenosi na Primatelja Ugovor u cijelosti, sa svim pratećim pravima i obvezama, a Primatelj prima Ugovor u cijelosti, sa svim pratećim pravima i obvezama. ',
                    value: '',
                },
                {
                    type: 'text',
                    mandatory: true,
                    editable: false,
                    content: 'Potpisom na ovom ugovoru Primatelj izrijekom potvrđuje da je upoznat sa sadržajem Ugovora te sa svim pravima i obvezama koje proizlaze iz istoga te da mu je uručen primjerak Ugovora koji se prenosi.',
                    value: '',
                }],
        },
        {
            title: "PREUZIMANJE PRAVA I OBVEZA",
            mandatory: false,
            statements: [
              {
                type: "text",
                mandatory: true,
                editable: true,
                content: "Trenutkom stupanja na snagu ovog ugovora, Primatelj u cijelosti preuzima na sebe sva prava i obveze koje proizlaze iz prenesenog Ugovora."
              }
            ]
          },
        {
            title: "SUGLASNOST ZA PRIJENOS",
            mandatory: false,
            statements: [
              {
                type: "text",
                mandatory: true,
                editable: true,
                content: "Druga strana je suglasna s takvim prijenosom, što potvrđuje svojim potpisom na ovom ugovoru te pristaje da Ugovor proizvodi pravne učinke od dana potpisa ovog ugovora."
              }
            ]
          },
          {
            title: "OBVEZE DRUGE STRANE",
            mandatory: false,
            statements: [
              {
                type: "text",
                mandatory: true,
                editable: true,
                content: "Davanjem suglasnosti na ovaj ugovor o prijenosu ugovora odnosno stupanjem na snagu ovog ugovora, Druga strana se obvezuje Primatelju svoje obveze iz Ugovora ispuniti o njihovom dospijeću."
              }
            ]
          },
        {
          title: 'JAMSTVO',
          mandatory: false,
          statements: [
            {
              type: 'choice',
              mandatory: true,
              editable: true,
              choices: [
                'Prenositelj ne jamči Primatelju za obveze Druge strane iz Ugovora, niti jamči Drugoj strani za obveze Primatelja iz Ugovora.',
                'Prenositelj ne jamči Primatelju za obveze Druge strane iz Ugovora, no jamči Drugoj strani za obveze Primatelja iz Ugovora.',
                'Prenositelj jamči Primatelju za obveze Druge strane iz Ugovora, no ne jamči Drugoj strani za obveze Primatelja iz Ugovora.',
                'Prenositelj jamči Primatelju za obveze Druge strane iz Ugovora te jamči Drugoj strani za obveze Primatelja iz Ugovora. ',
              ],
              placeholder: "Odaberite ovdje te potom izmijenite po želji...",
              help: 'Jamac za obveze iz trgovačkog ugovora se smatra jamcem platcem - odgovara za cijelu obvezu, te vjerovnik može zahtijevati ispunjenje, bilo od glavnog dužnika, bilo od jamca platca ili od obojice u isto vrijeme.',

            },
          ]
        },
        {
            title: "PRIMJENA UGOVORA",
            mandatory: false,
            statements: [
              {
                type: "text",
                mandatory: true,
                editable: true,
                content: "Ovaj Ugovor se primjenjuje od dana potpisa, a koji dan ujedno je i dan davanja suglasnosti Druge strane."
              }
            ]
          },
        {
            title: 'NADLEŽNOST',
            mandatory: false,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: false,
                    choices: [
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Svi sporovi koji proizađu ili budu u vezi s ovim ugovorom rješavati će se pred stvarno nadležnim sudom za Prenositelja.'
                                }
                            ]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Svi sporovi koji proizađu ili budu u vezi s ovim ugovorom rješavati će se pred stvarno nadležnim sudom za Primatelja.'
                                }
                            ]
                        },      
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Svi sporovi koji proizađu ili budu u vezi s ovim ugovorom rješavati će se pred stvarno nadležnim sudom u'
                                },
                                {type: 'input', value: '',help: "Upišite mjesno nadležni sud. Npr. ...sudom u Zagrebu; ...sudom u Splitu i sl..", required: true},
            ]
                        }
                    ],
                    value: '',
                }
            ]
        },
        {
          title: 'PRIMJERCI UGOVORA',
          mandatory: false,
          statements: [
              {
                  type: 'text',
                  required: false,
                  mandatory: true,
                  editable: true,
                  content: 'Ovaj Ugovor sastavljen je u 2 (dva) primjerka, od kojih svaka ugovorna strana zadržava po 1 (jedan) primjerak.',
                  value: '',
              }],
        },
        {
            mandatory: true,
            static: true,
            type: 2, // date and place
            statements: [
              {
                type: "input",
                mandatory: true,
                parts: [
                  {
                    type: "text",
                    content: "U"
                  },
                  {
                    type: "input",
                    value: "",
                    placeholder: "Upišite mjesto.",
                    required: true,
                  },
                  {
                    type: "text",
                    content: ", dana"
                  },
                  {
                    type: "date",
                    value: new Date(),
                    required: true
                  },
                  {
                    type: "text",
                    content: "godine."
                  }
                ]
              },
            ]
          },
        {
            mandatory: true,
            static: true,
            type: 3,  // signatures
            statements: [],
        },
    ],
};



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/49.5_ugovor_o_prijenosu_ugovora.ts